var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-subheader',{staticClass:"font--text toolsInfo",staticStyle:{"height":"auto"}},[_c('v-tooltip',{attrs:{"bottom":"","color":"font"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"text-truncate folderInfo",staticStyle:{"max-width":"13vw"}},on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }